export enum InspectionStandardType {
	PACP = 'pacp',
	WSA = 'wsa',
	MACP = 'macp',
}
